import { render, staticRenderFns } from "./InputDate.vue?vue&type=template&id=0b3571f7"
import script from "./InputDate.vue?vue&type=script&lang=js"
export * from "./InputDate.vue?vue&type=script&lang=js"
import style0 from "./InputDate.vue?vue&type=style&index=0&id=0b3571f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports